<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        v-if="id === ''"
        @back="back"
        title
        :content="$t('adicionar-tipo-faturamento')"
      ></el-page-header>
      <el-page-header
        v-if="id !== ''"
        @back="back"
        title
        :content="$t('atualizar-tipo-faturamento')"
      ></el-page-header>
    </el-card>
    <el-card>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-position="top"
        :status-icon="true"
        :rules="rules"
        :inline-message="true"
      >
        <el-form-item :label="$t('nome')" prop="name">
          <el-input ref="name" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('descricao')" prop="description">
          <el-input ref="description" v-model="ruleForm.description"></el-input>
        </el-form-item>
        <el-row :gutter="4">
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item :label="$t('tipo')" prop="type">
              <el-select v-model="ruleForm.type">
                <el-option value="4" key="4" :label="$t('diario')">{{
                  $t("diario")
                }}</el-option>
                <el-option value="3" key="3" :label="$t('semanal')">{{
                  $t("semanal")
                }}</el-option>
                <el-option value="2" key="2" :label="$t('quinzenal')">{{
                  $t("quinzenal")
                }}</el-option>
                <el-option value="1" key="1" :label="$t('mensal')">{{
                  $t("mensal")
                }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="4">
          <el-col
            v-show="ruleForm.type === '2'"
            :xs="24"
            :sm="12"
            :md="12"
            :lg="6"
            :xl="6"
          >
            <el-form-item :label="`${$t('quinzena')} 1`" prop="days">
              <el-date-picker
                v-model="ruleForm.q1"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="à"
                format="dd"
                start-placeholder="Inicio"
                end-placeholder="Fim"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col
            v-show="ruleForm.type === '2'"
            :xs="24"
            :sm="12"
            :md="12"
            :lg="6"
            :xl="6"
          >
            <el-form-item :label="`${$t('quinzena')} 2`" prop="days">
              <el-date-picker
                v-model="ruleForm.q2"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="à"
                format="dd"
                start-placeholder="Inicio"
                end-placeholder="Fim"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            v-show="ruleForm.type === '3'"
            :sm="12"
            :md="12"
            :lg="4"
            :xl="4"
          >
            <el-form-item :label="`${$t('semana')} 1`" prop="days">
              <el-date-picker
                v-model="ruleForm.s1"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="à"
                format="dd"
                start-placeholder="Inicio"
                end-placeholder="Fim"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col
            v-show="ruleForm.type === '3'"
            :xs="24"
            :sm="12"
            :md="12"
            :lg="4"
            :xl="4"
          >
            <el-form-item :label="`${$t('semana')} 2`" prop="days">
              <el-date-picker
                v-model="ruleForm.s2"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="à"
                format="dd"
                start-placeholder="Inicio"
                end-placeholder="Fim"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col
            v-show="ruleForm.type === '3'"
            :xs="24"
            :sm="12"
            :md="12"
            :lg="4"
            :xl="4"
          >
            <el-form-item :label="`${$t('semana')} 3`" prop="days">
              <el-date-picker
                v-model="ruleForm.s3"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="à"
                format="dd"
                start-placeholder="Inicio"
                end-placeholder="Fim"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col
            v-show="ruleForm.type === '3'"
            :xs="24"
            :sm="12"
            :md="12"
            :lg="4"
            :xl="4"
          >
            <el-form-item :label="`${$t('semana')} 4`" prop="days">
              <el-date-picker
                v-model="ruleForm.s4"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="à"
                format="dd"
                start-placeholder="Inicio"
                end-placeholder="Fim"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <br />
        <el-form-item style="text-align: center">
          <el-button
            type="warning"
            v-if="id === ''"
            autofocus
            @click="submitForm('ruleForm')"
            >{{ $t("adicionar") }}</el-button
          >
          <el-button
            type="warning"
            v-if="id !== ''"
            autofocus
            @click="editForm('ruleForm')"
            >{{ $t("atualizar") }}</el-button
          >
          <el-button type="danger" @click="back()">{{
            $t("voltar")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template> 
<script>
import { FinancialTypeService } from "@/services/customers/financial.type.services";
import { i18n } from "@/plugin/i18n";

export default {
  name: "CustomerAdd",
  data() {
    return {
      id: "",
      ruleForm: {
        name: "",
        description: "",
        type: "1",
        q1: new Date(),
        q2: new Date(),
        s1: new Date(),
        s2: new Date(),
        s3: new Date(),
        s4: new Date(),
      },
      rules: {
        name: [
          {
            required: true,
            message: i18n.tc("nome-obrigatorio"),
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: i18n.tc("descricao-obrigatorio"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.replace({
        name: "financial.type",
      });
    },
    get() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      FinancialTypeService.get(vm.id)
        .then((response) => {
          vm.ruleForm = response;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          FinancialTypeService.add(vm.ruleForm)
            .then((response) => {
              vm.$message({
                type: "success",
                message: i18n.tc("tipo-financeiro-adicionado-sucesso"),
              });
              vm.$refs[formName].resetFields();
            })
            .catch((error) => {
              vm.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          FinancialTypeService.update(vm.id, vm.ruleForm)
            .then((response) => {
              vm.$message({
                type: "success",
                message: i18n.tc("tipo-financeiro-atualizado-sucesso"),
              });
            })
            .catch((error) => {
              vm.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    const vm = this;
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      vm.get();
    } else {
      vm.$refs.name.$el.children[0].focus();
    }
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}
form {
  margin-top: 20px;
}
@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
